// Câmera primeira pessoa: eye height, FOV, land bob e view roll sutil — docs/02.
import * as THREE from 'three';
import { EYE_HEIGHT, EYE_HEIGHT_DUCK, UNIT_TO_METERS } from '@surfrun/shared';
import type { V3 } from '../physics/vec';

const DEG = Math.PI / 180;

export class FPCamera {
  camera: THREE.PerspectiveCamera;
  fovBase = 105;
  landBobEnabled = true;
  viewRollEnabled = true;

  private bobOffset = 0;   // units, negativo = dip
  private bobVel = 0;
  private roll = 0;        // graus

  constructor(aspect: number) {
    this.camera = new THREE.PerspectiveCamera(this.fovBase, aspect, 0.05, 4000);
    this.camera.rotation.order = 'YXZ';
  }

  onLand(landSpeed: number): void {
    if (!this.landBobEnabled) return;
    // dip proporcional à força do pouso (curto)
    this.bobVel = -Math.min(landSpeed * 0.06, 42);
  }

  update(
    interpPos: V3, ducked: boolean, yaw: number, pitch: number,
    sideInput: number, dtReal: number,
  ): void {
    // spring do land bob
    const K = 380, D = 22;
    this.bobVel += (-this.bobOffset * K - this.bobVel * D) * dtReal;
    this.bobOffset += this.bobVel * dtReal;

    // view roll sutil no strafe (estilo Momentum Mod)
    const targetRoll = this.viewRollEnabled ? -sideInput * 1.2 : 0;
    this.roll += (targetRoll - this.roll) * Math.min(1, dtReal * 10);

    const eyeH = (ducked ? EYE_HEIGHT_DUCK : EYE_HEIGHT) + this.bobOffset;
    this.camera.position.set(
      interpPos.x * UNIT_TO_METERS,
      (interpPos.y + eyeH) * UNIT_TO_METERS,
      interpPos.z * UNIT_TO_METERS,
    );
    this.camera.rotation.set(pitch * DEG, yaw * DEG, this.roll * DEG);
  }

  setFov(fov: number): void {
    this.fovBase = fov;
    this.camera.fov = fov;
    this.camera.updateProjectionMatrix();
  }

  resize(aspect: number): void {
    this.camera.aspect = aspect;
    this.camera.updateProjectionMatrix();
  }
}
